export default __webpack_public_path__ + "static/media/mesh_macring.262b1a8c.png";